(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  /* Announcement countdown. Liquid renders the digits; this keeps them
     moving and handles expiry in-session. Fails silently — nothing here may
     break a link in the bar. */
  (function () {
    var STARTED = 'annTimerStarted';

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }

    function start(el) {
      if (el.dataset[STARTED]) return;
      el.dataset[STARTED] = '1';

      var deadline = Date.parse(el.getAttribute('data-deadline') || '');
      var daysEl = el.querySelector('[data-ann-days]');
      var hmsEl = el.querySelector('[data-ann-hms]');
      if (isNaN(deadline) || !hmsEl) return;

      function expire() {
        var text = el.getAttribute('data-expired-text');
        var item = el.closest('.announcement-row__item');
        if (text) {
          el.textContent = '';
          var s = document.createElement('span');
          s.className = 'announcement-row__meta';
          s.textContent = text;
          el.appendChild(s);
        } else if (item) {
          item.remove();
        } else {
          el.hidden = true;
        }
      }

      function tick() {
        var left = Math.floor((deadline - Date.now()) / 1000);
        if (left <= 0) {
          expire();
          return;
        }
        var days = Math.floor(left / 86400);
        if (daysEl) {
          daysEl.textContent = days + 'd';
          daysEl.hidden = days === 0;
        }
        hmsEl.textContent =
          pad(Math.floor((left % 86400) / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
        window.setTimeout(tick, 1000 - (Date.now() % 1000));
      }

      tick();
    }

    function init() {
      [].forEach.call(document.querySelectorAll('[data-ann-timer]'), start);
    }

    init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muze-collaborators"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-collab-gallery]');
    if (!sections.length) return;

    sections.forEach((gallery) => {
      const track = gallery.querySelector('[data-collab-track]');
      const prev = gallery.querySelector('[data-collab-prev]');
      const next = gallery.querySelector('[data-collab-next]');
      if (!track || !prev || !next) return;

      const getStep = () => {
        const slide = track.querySelector('.collab__slide');
        if (!slide) return track.clientWidth * 0.7;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return slide.offsetWidth + gap;
      };

      const updateArrows = () => {
        const max = track.scrollWidth - track.clientWidth - 1;
        prev.toggleAttribute('disabled', track.scrollLeft <= 0);
        next.toggleAttribute('disabled', track.scrollLeft >= max);
      };

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
